import { render } from "./InformationMasterCourses.vue?vue&type=template&id=582bec41&scoped=true"
import script from "./InformationMasterCourses.vue?vue&type=script&lang=js"
export * from "./InformationMasterCourses.vue?vue&type=script&lang=js"

import "./InformationMasterCourses.vue?vue&type=style&index=0&id=582bec41&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-582bec41"]])

export default __exports__